/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TrimbleItemsControllerMatchProjectSightDrawingsBundleMutationResponse, TrimbleItemsControllerMatchProjectSightDrawingsBundleQueryParams } from "../../models/trimbleController/TrimbleItemsControllerMatchProjectSightDrawingsBundle";

function getTrimbleItemsControllerMatchProjectSightDrawingsBundleUrl() {
  const res = { method: 'POST', url: `/api/v1/trimble/projectsight/drawings/bundle/import-match` as const }  
  return res
}

/**
 * @summary Find a file in the destination project imported from exactly these drawings
 * {@link /api/v1/trimble/projectsight/drawings/bundle/import-match}
 */
export async function trimbleItemsControllerMatchProjectSightDrawingsBundle(params: TrimbleItemsControllerMatchProjectSightDrawingsBundleQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TrimbleItemsControllerMatchProjectSightDrawingsBundleMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getTrimbleItemsControllerMatchProjectSightDrawingsBundleUrl().url.toString(), params, ... requestConfig })  
  return res.data
}